import styled from 'styled-components'

import { Section as SectionGS, Infos as InfosGS } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { media, colors, space, radii, borderWidths, zIndices } = theme

export const Section = styled(SectionGS)`
  padding-bottom: 0;
  background-color: ${colors['neutral-background-contrast-medium']};

  @media (${media.tablet}) {
    padding-bottom: ${space['spacing-xxl']};
  }

  @media (${media.desktop}) {
    padding-bottom: 7.5rem;
  }
`

export const Infos = styled(InfosGS)`
  h4 {
    margin-bottom: ${space['spacing-xl']};
  }

  @media (${media.tablet}) {
    max-width: 31rem;
  }

  @media (${media.desktop}) {
    min-height: 27.188rem;
  }
`

export const Card = styled.div`
  width: 19rem;
  height: 100%;
  padding: ${space['spacing-sm']};
  border: ${borderWidths['border-stroke-micro']} solid ${colors['neutral-border-default']};
  border-radius: ${radii['corner-radius-md']};
  background-color: ${colors['neutral-background-default']};
  cursor: grab;

  h3 {
    margin-bottom: 14px;
  }

  @media (${media.desktop}) {
    width: 33rem;
  }
`

export const CarouselWrapper = styled.div`
  position: relative;
  margin-right: -${space['spacing-md']};
  padding-bottom: ${space['spacing-xxxl']};
  overflow: hidden;

  > div:first-child {
    width: 19rem;
    overflow: unset;
  }

  .controls-wrapper {
    position: relative;
    z-index: ${zIndices[1]};
    margin-top: ${space['spacing-lg']};
    padding-right: ${space['spacing-md']};
  }

  @media (${media.desktop}) {
    position: absolute;
    left: 50%;
    right: ${space['spacing-md']};

    > div:first-child {
      width: 33rem;
    }
  }
`

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space['spacing-xl']};
  height: ${space['spacing-xl']};
  margin-bottom: ${space['spacing-sm']};
  border-radius: ${radii['corner-radius-circular']};
  background-color: ${colors['neutral-background-medium']};
`

export const CardContent = styled.div`
  > *:not(:last-child) {
    margin-bottom: ${space['spacing-md']};
  }
`
